/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext, Dispatch, SetStateAction } from "react"

export interface AuthContextInterface {
      getLoggedInUser: any
      setLoggedInUser: Dispatch<SetStateAction<any>>
    }
    const defaultState = {
      getLoggedInUser: async () => {},
      setLoggedInUser: async () => {},
    } as AuthContextInterface
    
    export const AuthContext = createContext(defaultState)